import MultiSelect from 'components/MultiSelect';
import { ComponentProps } from 'react';
import { TaskType } from 'types/common';

const taskTypeOptions: Array<{ label: string; value: TaskType }> = [
  {
    label: 'Get Install Pipe Date',
    value: 'PIPE_INSTALLATION_DATE',
  },
  {
    label: 'Actual Planting date',
    value: 'START_SEASON',
  },
  {
    label: 'Fertiliser Data',
    value: 'FERTILIZER_LOG',
  },
  {
    label: 'Pipe Installation',
    value: 'PIPE_INSTALLATION',
  },
  {
    label: 'Drying Event 1',
    value: 'DRYING_EVENT_1',
  },
  {
    label: 'Drying Event 2',
    value: 'DRYING_EVENT_2',
  },
  {
    label: 'Drying Event 2',
    value: 'DRYING_EVENT_3',
  },
  {
    label: 'Pre Harvest Meeting',
    value: 'PRE_HARVEST_MEETING',
  },
  {
    label: 'Harvest Data',
    value: 'HARVEST',
  },
];

const TaskTypeFilter = (props: Partial<ComponentProps<typeof MultiSelect>>) => {
  return (
    <MultiSelect
      label={props?.label ?? 'Task Type'}
      options={taskTypeOptions}
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      allowClear
    />
  );
};

export default TaskTypeFilter;
